/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useCallback, useContext } from 'react'
import { useState, useRef } from 'react'
import { createTask, fetchTaskList } from '../../Components/action/common'
import { useDispatch, useSelector } from 'react-redux'
import {
  pushAllTaskList,
  pushCompletedTaskList,
  pushGroupedList,
  pushNoDateTaskList,
  pushOverDueTaskList,
  pushSetTaskList,
  setFocusTasksList,
  setTaskProjects
} from '../../redux/slices/TaskSlice'
import { setAllProjectsList, setProjectsListWithTasksCount, setProjectTasks } from '../../redux/slices/ProjectSlice'
// import { setAllGoalsList } from '../../redux/slices/GoalSlice'
import { useEffect } from 'react'
import moment from 'moment'
import momentTimezone from 'moment-timezone';
import Datepicker from '../../Components/DatePicker/components/Datepicker'
import { jsx } from "@emotion/core";
import CalendarIcon from './CalendarIcon'
import { calendarFormat, format, isValidDate, extractMentions, removeMentionsAndConvertToHTML, getEditorContent } from '../../Components/action/utilities'
import Select from 'react-select'
import RepeatedTaskModal from '../Settings/Modal/RepeatedTaskModal'
import { RRule } from 'rrule'
// import TaskInputField from '../../Components/common/TaskInputField'
import { fetchProjectList } from '../../Components/action/tasks'
import { usePosthog } from '../../PosthogProvider'
import MediumLikeEditorWithMentions from '../../Components/common/MediumLikeEditorWithMentions'
import Tooltip from '../../Components/common/Tooltip'
// import { fetchGoalList } from '../../Components/action/goals'
import DateTimePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

function AddTask({ fetchTotalCount, currentPage, groupDate, setSelectedDate = (date) => {}, selectedDate, completedList, fetchAddTaskData, onAddTaskUpdate, setTodayTaskList, upComing, onHide, setFocus = false, isActive = true, focusTimerState = {}, isSettled = true, groupKey = null, projectId = null, onlyRecurringTasks = false, endTime = null}) {
  const dispatch = useDispatch()
  const inputRef = useRef('');
  const projectOptionsRef = useRef(null);
  //const titleRef = useRef();
  const editorRef = useRef();
  const { captureEvent } = usePosthog();

  // global state
  const { headerName, taskDaySelected, focusTasksList, taskProjects } = useSelector(state => state.task)
  const dateChange = useSelector(state => projectId ? null : state.task.dateChange)
  const { allProjectsList } = useSelector(state => state.project)
  // const { allGoalsList } = useSelector(state => state.goal)
  const { colorPicker, colorPickerDark, theme } = useSelector(state => state.theme)
  const [selectedDay, setSelectedDay] = useState(taskDaySelected);
  const [addTaskFocus, setAddTaskFocus] = useState(setFocus)
  const [onDateChage, setOnDateChage] = useState(null)
  // const [onStartTimeChange, setOnStartTimeChange] = useState(new Date())
  // const [onEndTimeChange, setOnEndTimeChange] = useState(new Date())
  const [onInputFocus, setOnInputFocus] = useState(setFocus)
  const [inputFieldValue, setInputFieldValue] = useState(false)
  const [taskTitle, setTaskTitle] = useState('');
  const [taskDescription, setTaskDescription] = useState('');
  const [selectedRepeat, setSelectedRepeat] = useState(1);
  const [repeatListOptions, setRepeatListOptions] = useState([]);
  const [openCustomRepeat, setOpenCustomRepeat] = useState(false);
  const [selectedProject, setSelectedProject] = useState(groupKey);
  const repeatOptionsRef = useRef(null);

  const initRepeatListOptions = useCallback(() => {
    const TaskDate = {
      from: onDateChage || new Date()
    }
    const dtstart = momentTimezone(TaskDate?.from).tz(momentTimezone.tz.guess()).endOf('day').toDate()
    let selectRepeatList = [
      { value: 1, label: `Does not repeat`, rule: null },
      { value: 2, label: `Daily`, rule: (new RRule({dtstart, freq: RRule.DAILY})).toString() },
      { value: 3, label: `Weekly on ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.WEEKLY, interval: 1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 4, label: `Monthly on the first ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.MONTHLY, interval: 1, bysetpos: 1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 5, label: `Monthly on the last ${TaskDate?.from && format(TaskDate.from, "dddd")}`, rule: (new RRule({dtstart, freq: RRule.MONTHLY, interval: 1, bysetpos: -1, byweekday: RRule[format(TaskDate?.from, "dddd").toUpperCase().slice(0, 2)]})).toString() },
      { value: 6, label: `Annually on ${TaskDate?.from && format(TaskDate.from, "MMMM DD")}`, rule: (new RRule({dtstart, freq: RRule.YEARLY, interval: 1})).toString() },
      { value: 7, label: `Every weekday (Monday to Friday)`, rule: (new RRule({dtstart, freq: RRule.WEEKLY, byweekday: [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR]})).toString() },
      { value: 99, label: null, rule: null },
      { value: 100, label: `Custom...`, rule: null }
    ];

    if(onlyRecurringTasks){
      selectRepeatList = selectRepeatList.filter(item => item.value !== 1);
      setSelectedRepeat(2)
    }else{
      setSelectedRepeat(1)
    }

    setRepeatListOptions(selectRepeatList)
  }, [onDateChage]);

  useEffect(() => {
   setSelectedDay(currentPage == 'noDate' ? 'No Date' : taskDaySelected)
  }, [taskDaySelected])

  const reset = () => {
    setTaskTitle('');
  }

  const onAddTask = async () => {
    //const data = getValues();
    const dateTime = moment(dateChange).format('YYYY-MM-DD')
    let date = null;
    let endDateTime = null;
    let startTime = 0;
    let endTime = 0;
    
    try{
      switch (selectedDay) {
        case 'No Date':
          date = null
          break;
        default:
          // if(onStartTimeChange && onEndTimeChange){
          //   startTime = moment(onStartTimeChange).format('HH:mm')
          //   endTime = moment(onEndTimeChange).format('HH:mm')
          //   startTime = parseInt(startTime.split(':')[0]) * 60 + parseInt(startTime.split(':')[1])
          //   endTime = parseInt(endTime.split(':')[0]) * 60 + parseInt(endTime.split(':')[1])
          //   if(startTime > 0 && endTime > 0){
          //     endDateTime = new Date(moment(onDateChage).startOf('date').add(endTime, 'minutes')).toISOString()
          //   }
          // }
          date = new Date(moment(onDateChage).startOf('date').add(startTime, 'minutes')).toISOString()
      }
    }catch(e){
      date = null
    }
  
    const taskDescription = getEditorContent('description', editorRef);
    const title = removeMentionsAndConvertToHTML('title', editorRef);
    const { projectMentions: projects} = extractMentions("title", editorRef);
    const project = projects?.[0]?.name ?? selectedProject;
    // const goal = goals?.[0]?.name ?? null;
    // const goalId = allGoalsList?.find(item => item.name == goal)?.id ?? null;
    const tags = [];
    
    if (title.length > 0) {
      try {
        const requestBody = {
          "title": title,
          "description": taskDescription,
          "tags": tags ?? [],
          "project": project,
          "goalId": null, //goalId,
          "date": date,
          "endDateTime": endDateTime,
          "repeat": repeatListOptions.filter(item => item.value === selectedRepeat)?.[0] ?? null,
          "status": completedList === true ? 1 : 0
        }
        let response = await createTask(requestBody)
        if(response?.data?.responseData?.data){
          response.data.responseData.data.Project = project ? {title: project} : null
          response.data.responseData.data.Tags = tags ? tags.map((tag, index) => ({name: tag, id: index+1})) : [];
        }
        if(project){
          let projects = [];
          if(taskProjects.find(item => item.title.toLowerCase() == project.toLowerCase())){
            projects = taskProjects;
          }else{
            projects = [{title: project}, ...taskProjects];
          }
          dispatch(setTaskProjects(projects))
        }
        switch (currentPage) {
          case 'upComing':
            dispatch(pushGroupedList(response?.data?.responseData?.data))
            break;

          case 'overDue':
            dispatch(pushOverDueTaskList(response?.data?.responseData?.data))
            // fetchTotalCount()
            break;

          case 'allTask':
            dispatch(pushAllTaskList(response?.data?.responseData?.data))
            // fetchTotalCount()
            break;

          case 'noDate':
            dispatch(pushNoDateTaskList(response?.data?.responseData?.data))
            // fetchTotalCount()
            break;
          case 'completedList':
            dispatch(pushCompletedTaskList(response?.data?.responseData?.data))
           // fetchTotalCount()
            break;

          default:
            // if (moment(response?.data?.responseData?.data?.date).format('YYYY-MM-DD') == dateTime) {
            dispatch(pushSetTaskList(response?.data?.responseData?.data));
            const {pause, start, activeTimer, fullscreen} = focusTimerState;
            //console.log({pause, start, activeTimer, fullscreen, focusTasksList})
            if(pause === false && start === true && activeTimer === 'focusMode' && fullscreen === true){
              dispatch(setFocusTasksList([...focusTasksList, {...response?.data?.responseData?.data, focus: 1}]));
            }

            if (dateTime != moment().format('YYYY-MM-DD')) {
              setSelectedDay('DatePicker')
            } else {
              setSelectedDay('Today')
            }
        }

        if(fetchTotalCount){
          fetchTotalCount();
        }

        if(projectId){
          const [pId, projectSource] = projectId.split('_');
          fetchTaskList({projectId: pId, status: 0}).then((res) => {
            dispatch(setProjectTasks(res?.data?.responseData ?? []));
          })
          fetchProjectList({includeTasksCount: true, ordering: '1'}).then((res) => {
            dispatch(setProjectsListWithTasksCount(res?.data?.responseData?.data ?? []))
          })
        }else if(currentPage !== 'home'){
          fetchProjectList({includeTasksCount: true, ordering: '1'}).then((res) => {
            dispatch(setProjectsListWithTasksCount(res?.data?.responseData?.data ?? []))
          })
        }

        // Capture add task event
        captureEvent(`New Task Added ${project ? `- Project: ${project}` : ''}`, {
          project: project
        });

        if(project?.length > 0){
          getProjects();
        }

        if(onHide){
          onHide(response?.data?.responseData?.data);
          return;
        }

        setOnInputFocus(false)
        setAddTaskFocus(false)
        if (currentPage == "upComing") {
          setOnInputFocus(false)
          let repotionsBlock = document.getElementById(groupDate)
          if (repotionsBlock) repotionsBlock.style.display = "none"
          setAddTaskFocus(false);
          reset()
        } else {
          reset()
          let repotionsBlock = inputRef.current; //document.querySelector("#repotionsBlock")
          repotionsBlock.style.display = "none"
        }

        setSelectedDate(dateTime)
        if (dateTime == selectedDate) {
          fetchAddTaskData()
        }
        if(setTodayTaskList)
          setTodayTaskList(true)
        if(onAddTaskUpdate)
          onAddTaskUpdate()

      } catch (response) {
        //console.log('ERROR==>', response)
      }
    }
  }

  const selectDayOfDate = (date) => {
    if ((moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD') == moment().format('YYYY-MM-DD'))) {
      setSelectedDay('Today')
    } else if ((moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD') == moment(new Date(moment().startOf().add(1, 'days'))).format('YYYY-MM-DD'))) {
      setSelectedDay('Tomorrow')
    } else if ((moment(date, 'MM/DD/YYYY').format('YYYY-MM-DD') == moment(new Date(moment().startOf().add(7, 'days'))).format('YYYY-MM-DD'))) {
      setSelectedDay('Next Week')
    } else {
      setSelectedDay('DatePicker')
    }
  }

  const addTaskOnupComingFocus = (groupDate) => {
    setOnInputFocus(true)
    selectDayOfDate(groupDate);

    let repotionsBlock = document.getElementById(groupDate)
    if (repotionsBlock) {
      repotionsBlock.style.display = "block"
    }
    setAddTaskFocus(true)
  }

  const addTaskOnFocus = () => {
    setOnInputFocus(true)
    let repotionsBlock = inputRef.current; //document.getElementById("repotionsBlock")
    if (repotionsBlock) {
      repotionsBlock.style.display = "block";
    }
    setAddTaskFocus(true)
  }

  const onCancelUpComingTask = (groupDate) => {
    setOnInputFocus(false)
    let repotionsBlock = document.getElementById(groupDate)
    if (repotionsBlock) repotionsBlock.style.display = "none"
    setAddTaskFocus(false);
    reset();
    setSelectedRepeat(1)

    if(onHide)
      onHide();
  }
  const onCancelTask = (e) => {
    setOnInputFocus(false)
    inputRef.current.style.display = "none";
    setAddTaskFocus(false);
    reset();
    setSelectedRepeat(1)

    if(onHide)
      onHide();
  }

  const onClickDateRangeSet = (day) => {
    setSelectedDay(day)
    handleAddTaskFilter(day)
  }

  const onDatePickerDateChange = (e) => {
    setOnDateChage(e)
  }

  function handleAddTaskFilter(taskDaySelected) {
    let date = null
    if (taskDaySelected === 'Today') {
      date = new Date()
    } else if (taskDaySelected === 'Tomorrow') {
      date = new Date(moment().startOf().add(1, 'days'))
    } else if (taskDaySelected === 'Next Week') {
      // date = moment(date).add(7, 'days').toISOString()
      date = new Date(moment().add(7, 'days'))
    }
    else {
      date = null
    }

    if (date)
      setOnDateChage(date);
  }

  const onInputValueChange = (value) => {
    if (value != "") {
      setInputFieldValue(true)
    } else {
      setInputFieldValue(false)
    }
  }

  // Fetch projects list
  const getProjects = async () => {
    const {data} = await fetchProjectList();
    const projects = data?.responseData?.data ? data?.responseData?.data?.map(option => ({value: option.title, label: option.title})) : [];
    dispatch(setAllProjectsList(projects))
  }

  // Fetch projects list
  // const getGoals = async () => {
  //   const {data} = await fetchGoalList();
  //   const goals = data?.responseData ?? [];
  //   dispatch(setAllGoalsList(goals))
  // }

  useEffect(() => {
    switch (headerName) {
      case 'All':
        setSelectedDay("Today")
        break;
      case 'Overdue':
        setSelectedDay("Today")
        break;
      case 'Completed':
        setSelectedDay("Today")
        break;
      case 'NoDate':
        setSelectedDay('No Date')
        break;
      default:
    }
  }, [headerName])

  useEffect(() => {
    let currentDate = moment(dateChange).format('D MMM YYYY');
    setOnDateChage(groupDate ?? currentDate);
    // setOnStartTimeChange(groupDate ? groupDate : moment().add(30 - (moment().minute() % 30), 'minutes').toDate());
    // setOnEndTimeChange(endTime ? endTime : moment().add(60 - (moment().minute() % 30), 'minutes').toDate());
    getProjects();
    // getGoals();
  }, [])

  useEffect(() => {
    !groupDate && setOnDateChage(dateChange)
  }, [dateChange])

  useEffect(() => {
    initRepeatListOptions();
  }, [onDateChage])

  // useEffect(() => {
  //   setTaskTitle(title => {
  //     let newTitle = title.replace(/@\[[^\]]+\]/g, '');
  //     if(selectedProject !== null && selectedProject !== '@'){
  //       newTitle = newTitle.trim();
  //       newTitle += ` @[${selectedProject}] `;
  //     }
  //     //titleRef?.current?.focus();
  //     return newTitle
  //   })
  // }, [selectedProject])

  const CustomStyle = {
    singleValue: (base, state) => {
      return {
        ...base,
        background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
        lineHeight: 'normal',
        WebkitTextFillColor: 'transparent',
        WebkitBackgroundClip: 'text !important'
      }
    },
   option: (base, state) => {
      let background = 'var(--theme-mode-color-white)';
      let color = 'var(--theme-mode-color-white-reverse)';
      let backgroundImage = 'none';
      let backgroundPosition = '0 0';
      let opacity = 1;
      let fontWeight = '400';
      // const isFirstOption = state.options.indexOf(state.data) === 0;
      
      // if (isFirstOption) {
      //   opacity = 0.5;
      // }

      if (state.isFocused) {
        background = `linear-gradient(0deg,rgba(var(--theme-mode-rgb-white),0.9),rgba(var(--theme-mode-rgb-white),0.9)),var(--accent-color) !important`;
      }

      if (state.isSelected) {
        fontWeight = '600';
        //color = "white !important";
        background = `transparent url('data:image/svg+xml;charset=UTF-8,%3Csvg width%3D%2214%22 height%3D%2210%22 viewBox%3D%220 0 14 10%22 fill%3D%22none%22 xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath d%3D%22M13 1L4.75 9.25L1 5.5%22 stroke%3D%22${(theme == 'dark' ? colorPickerDark : colorPicker).replace(/^#/, '%23')}%22 stroke-width%3D%221.5%22 stroke-linecap%3D%22round%22 stroke-linejoin%3D%22round%22/%3E%3C/svg%3E') no-repeat !important`;
        backgroundPosition = 'right 20px center !important';
      }

      return {
        ...base,
        color,
        background,
        backgroundImage,
        backgroundPosition,
        opacity,
        fontWeight
      };
    }
  } 

  const setCustomRule = (value) => {
    if(value?.rule){
      setSelectedRepeat(99);
      setRepeatListOptions(options => options.map(option => option.value === 99 ? {...option, ...value} : option));
    }else{
      setOpenCustomRepeat(value);
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey && !e.shiftKey) {
      e.preventDefault(); // Prevent default form submission
      onAddTask();
    }else{
      if (e.key == 'Escape' || e.keyCode === 27) {
        onHide();
      }
    }
  };

  const onChangeHandler = (mentions) => {
    if(mentions.length > 0){
      setSelectedProject(mentions[mentions.length - 1].name) 
    }else{
      setSelectedProject(null)
    }
  }

  return (
    <>
      <div className={`type-header  ${onInputFocus ? 'bg-light-addTask' : ''}`}>
        <form onSubmit={(e) => {
          e.preventDefault();
          onAddTask();
        }}
        className="add-task-form">
          <div className="filed-type bg-white dark:bg-black dark:border-white" css={{
            input: {
              color: theme == "dark" ? "white !important" : ""
            }
          }}>
            {
              allProjectsList !== null &&
              <MediumLikeEditorWithMentions onHide={onHide} ref={editorRef} onChange={onChangeHandler}  projects={allProjectsList} taskDescription={taskDescription} taskTitle={taskTitle} handleKeyPress={handleKeyPress} setFocus={setFocus} currentPage={currentPage} addTaskOnupComingFocus={addTaskOnupComingFocus} onDateChage={onDateChage} addTaskOnFocus={addTaskOnFocus} selectedProject={selectedProject} />  
            }
          </div>
          <div ref={inputRef} className="repetions-block" id={currentPage == "upComing" ? groupDate : 'repotionsBlock'} style={{ display: setFocus ? "block" : "none" }}>
            <div className="task-repetions">
              <div className="add-repetions">
                <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`} onClick={() => onClickDateRangeSet('DatePicker')}>
                    <CalendarIcon color="gray" width={14} height={14} />
                    <span className="sl-ico" css={{
                        background: `linear-gradient(rgba(var(--theme-mode-rgb-white-reverse), 0.7), rgba(var(--theme-mode-rgb-white-reverse), 0.7)), var(--accent-color)`,
                        whiteSpace: 'nowrap'
                      }}>
                      {calendarFormat(onDateChage)}
                    </span> 
                  <Datepicker onChange={(e) => { onDatePickerDateChange(e) }} value={currentPage == "upComing" ? onDateChage : dateChange} />
                </div>
                {/* {
                  isValidDate(onDateChage) &&
                  <>
                    <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}>
                        <DateTimePicker
                        selected={onStartTimeChange}
                        onChange={(date) => {
                          setOnStartTimeChange(date)
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        showTimeCaption={false}
                        minTime={new Date().setHours(0, 0)}
                        maxTime={onEndTimeChange}
                        className="w-[60px] light-primary-color dark:bg-black outline-[0]"
                      />
                    </div>
                    <div className={`cs-select text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}>
                      <DateTimePicker
                        selected={onEndTimeChange}
                        onChange={(date) => setOnEndTimeChange(date)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        dateFormat="h:mm aa"
                        showTimeCaption={false}
                        minTime={onStartTimeChange}
                        maxTime={new Date().setHours(23, 59)}
                        className="w-[60px] light-primary-color dark:bg-black outline-[0]"
                      />
                    </div>
                  </>
                } */}
                {
                  isValidDate(onDateChage) 
                  &&
                  <div ref={repeatOptionsRef} className={`cs-select recurring-options-dropdown text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black dark:invert-0 ${selectedDay === 'Custom' ? 'activeDate' : ''} `}>
                    <Select
                        styles={CustomStyle}
                        onChange={(value) => value.value === 100 ? setOpenCustomRepeat(true) : setSelectedRepeat(value.value)}
                        options={repeatListOptions.filter(option => option.label !== null)}
                        value={repeatListOptions.filter(option => option.value === selectedRepeat)[0]}
                        classNamePrefix={"repeating-task-setting" || ""}
                        classNames={{container: () => 'react-select repeated-task-select', control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                    />
                    {
                      openCustomRepeat
                      &&
                      <RepeatedTaskModal targetRef={repeatOptionsRef} onHide={(value = null) => setCustomRule(value)} task={{date: onDateChage || new Date()}} />
                    }
                  </div>
                }
                <div ref={projectOptionsRef} className={`cs-select projects-tags-dropdown text-black dark:text-white border border-black dark:border-[rgba(255,255,255,0.2)] bg-white dark:bg-black`}
                    css={{
                      '.repeated-task-select': {
                        '.repeating-task-setting__menu-list': {
                          maxHeight: '300px !important'
                        }
                      },
                      '.tooltip-hover':{
                        '&:hover':{
                          '&::after':{
                            height: '75% !important'
                          }
                        }
                      },
                      '&.active': {
                        '.tooltip-hover':{
                          '&:hover':{
                            '&::after':{
                              display: 'none !important'
                            },
                            '~ span.tooltip-text':{
                                display: 'none !important'
                            }
                          }
                        }
                      }
                    }}>
                      <Tooltip className='overDue-tooltip tooltip-mt0' text="Type '@' to assign this task to a project">
                          <a className="hovr-btn tooltip-hover">
                            <Select
                              styles={CustomStyle}
                              placeholder="Project"
                              onChange={(value) => setSelectedProject(value.value)}
                              options={[{value: null, label: 'None'}, ...(allProjectsList ? allProjectsList : [] )]}
                              value={allProjectsList?.filter(option => option.value === selectedProject)?.[0] ?? null}
                              classNamePrefix={"repeating-task-setting"}
                              onMenuOpen={() => projectOptionsRef.current.classList.add('active')}
                              onMenuClose={() => projectOptionsRef.current.classList.remove('active')}
                              classNames={{container: () => 'react-select repeated-task-select', control: () => 'dark:bg-black', menu: () => 'dark:bg-black', option: () => 'dark:bg-black dark:text-white', singleValue: () => 'dark:text-white'}}
                            />
                          </a>
                      </Tooltip>
                </div>
              </div>
              <div className="repetions-action">
                <div className='repeTions'>
                  <button type="button" className="recAct-btn cancel-btn border border-black/5 text-black dark:!text-white/50 bg-white dark:!bg-black" onClick={() => { upComing == true ? onCancelUpComingTask(groupDate) : onCancelTask() }}>
                      Cancel
                  </button>
                  <div className="repeTions">
                    <button type='submit' className="recAct-btn save-btn border border-black/5 text-white bg-[var(--accent-color-theme)]">Add Task</button> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default AddTask